{
  "name": "rsa-front",
  "version": "5.21.2",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve",
    "start:docker": "ng serve --host 0.0.0.0 --disable-host-check --poll 500",
    "start:prod": "ng serve --prod",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "format-all": "prettier --write \"src/**/*.ts\"",
    "tslint-check": "tslint-config-prettier-check ./tslint.json",
    "test": "jest",
    "test:all": "node --expose-gc ./node_modules/.bin/jest --runInBand --logHeapUsage # limit Jest memory usage",
    "test:clear": "jest --clearCache",
    "test:watch": "jest --watch",
    "test:ci": "jest --runInBand",
    "test:export": "jest --reporters=\"./src/jest-csv-reporter\"",
    "test:cov": "jest --coverage",
    "show:log": "docker logs insertis-front-1 -f",
    "release": "standard-version"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "<rootDir>/src/jest-setup.ts"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.5",
    "@angular/cdk": "^20.2.9",
    "@angular/common": "^20.3.5",
    "@angular/compiler": "^20.3.5",
    "@angular/core": "^20.3.5",
    "@angular/forms": "^20.3.5",
    "@angular/localize": "^20.3.5",
    "@angular/material": "^20.2.9",
    "@angular/platform-browser": "^20.3.5",
    "@angular/platform-browser-dynamic": "^20.3.5",
    "@angular/router": "^20.3.5",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ng-select/ng-select": "^20.3.1",
    "angular-calendar": "^0.32.0",
    "bootstrap": "^5.3.8",
    "core-js": "^3.46.0",
    "crypto-js": "^4.2.0",
    "file-saver": "^2.0.5",
    "jest-environment-jsdom": "^29.7.0",
    "moment": "^2.30.1",
    "ngx-quill": "^28.0.1",
    "numeral": "2.0.6",
    "quill": "2.0.3",
    "quill-image-resize-module": "3.0.0",
    "rxjs": "^7.8.2",
    "signature_pad": "^5.1.1",
    "standard-version": "^9.5.0",
    "ts-cacheable": "1.0.19",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.3.6",
    "@angular/compiler-cli": "^20.3.5",
    "@angular/language-service": "^20.3.5",
    "@types/crypto-js": "^4.2.2",
    "@types/jest": "^30.0.0",
    "@types/node": "^24.8.0",
    "eslint": "^9.37.0",
    "jest": "^30.2.0",
    "jest-preset-angular": "^15.0.2",
    "jquery": "^3.7.1",
    "npm-run-all": "4.1.5",
    "prettier": "^3.6.2",
    "ts-jest": "^29.4.5",
    "ts-mockito": "^2.6.1",
    "typescript": "^5.9.3"
  },
  "browser": {
    "crypto": false
  }
}
